<div class="container-fluid p-0 text-center mt-4 d-flex justify-content-center align-items-center position-relative overflow-hidden banner-container px-3">
  <img [src]="data?.links || 'https://services.apnasite.in/iam-citizen-components/images/bannerImage.jpg'" class="img-fluid w-100 position-absolute top-0 start-0 banner-img" alt="Banner Image">
</div>
